var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.8 23.8",
    style: {
      enableBackground: "new 0 0 23.8 23.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,5.7L20.9,0H2.9l0.8,5.7H0v0.4C0,12,5.1,16.8,11.3,16.8C10.8,18.4,8.8,23,4.9,23v0.8h14V23c-3.9,0-5.9-4.6-6.4-6.2 c6.3,0,11.3-4.8,11.3-10.7V5.7H20z M19.9,0.8L19,7.1c-0.7,4.3-3.2,8.9-7.1,8.9C8,16,5.5,11.5,4.8,7.1L3.9,0.8H19.9z M0.8,6.5h3.1 L4,7.2c0.5,3.1,1.9,6.5,4.3,8.3C4.1,14.4,1,10.8,0.8,6.5z M16,23H7.8c2.2-1.3,3.5-3.9,4.1-5.4C12.5,19.1,13.8,21.7,16,23z  M15.4,15.6c2.4-1.8,3.9-5.1,4.4-8.4l0.1-0.7H23C22.8,10.8,19.7,14.4,15.4,15.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.bb891f80f94457fa04c98e77dd8b3828.svg";
export { ForwardRef as ReactComponent };